// extracted by mini-css-extract-plugin
export default {"results":"clientList_results__D2Wol","clientInfo":"clientList_clientInfo__Vcrse"};